import { setBlocks } from "stores/slice/bogus/dashboard/const";

const dashboardConfig = {
  // API/gluon/users/Read Dashboard Layout
  "users/dashboard.read": {
    protocol: "ws",
    resource: "/users/dashboard",
    restful: false,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "dashboard",
  },
  // API/gluon/users/Update Dashboard Layout
  "users/dashboard.update": {
    protocol: "ws",
    resource: "/users/dashboard",
    restful: false,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: setBlocks,
    mockSelector: "dashboard",
  },
  // read top 5 , cpu, memory, poe and PoE Power Consumption
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/stats
  "/ents/:entId/orgs/:orgId/sites/:siteId/stats.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "dashboardStats",
  },
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/stats (standalone)
  "/orgs/:orgId/sites/:siteId/stats.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "dashboardStats",
  },
};

export default dashboardConfig;
